export default "__VITE_ASSET__c19ab144__"